(function () {
  'use strict';

  function applyMobileTypography() {
    const pdpModulesContentHeadline = document.querySelector('.Pdp-Modules-Content h2');
    if (pdpModulesContentHeadline) {
      pdpModulesContentHeadline.classList.remove('txt-headline-2xl-bold');
      pdpModulesContentHeadline.classList.add('txt-headline-2xl-bold');
    }

    document.querySelectorAll('.Pdp-Modules-Card-Title-Wrapper p').forEach((label) => {
      label.classList.remove('txt-body-s-regular');
      label.classList.add('txt-label-m-regular');
    });

    document.querySelectorAll('.Pdp-Modules-Card-Title-Wrapper h3').forEach((title) => {
      title.classList.remove('txt-headline-m-bold');
      title.classList.add('txt-body-m-bold');
    });

    document
      .querySelectorAll('.Pdp-Modules-Card-Date-Wrapper p, .Pdp-Modules-Card-Time-Wrapper p')
      .forEach((dateTime) => {
        dateTime.classList.remove('txt-body-m-regular');
        dateTime.classList.add('txt-label-m-regular');
      });

    document.querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper h4').forEach((hiddenHeadline) => {
      hiddenHeadline.classList.remove('txt-body-s-bold');
      hiddenHeadline.classList.add('txt-body-s-bold');
    });

    document.querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper p').forEach((hiddenSubtext) => {
      hiddenSubtext.classList.remove('txt-body-m-regular');
      hiddenSubtext.classList.add('txt-body-s-regular');
    });

    document.querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper h4').forEach((expertsHeadline) => {
      expertsHeadline.classList.remove('txt-body-s-bold');
      expertsHeadline.classList.add('txt-body-s-bold');
    });

    document
      .querySelectorAll('.Pdp-Modules-Card-Hidden-Speaker-Titel-Wrapper > p:first-child')
      .forEach((expertName) => {
        expertName.classList.remove('txt-body-m-regular');
        expertName.classList.add('txt-body-s-regular');
      });

    document
      .querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper > .metafield-rich_text_field > strong')
      .forEach((element) => {
        element.className = '';
        element.classList.add('txt-body-m-bold');
        element.style.marginBottom = '8px';
      });

    document
      .querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper > .metafield-rich_text_field > p')
      .forEach((element) => {
        element.className = '';
        element.classList.add('txt-body-m-regular');
      });

    document
      .querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper > .metafield-rich_text_field > ul')
      .forEach((element) => {
        element.style.listStylePosition = 'outside';
      });

    document
      .querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper > .metafield-rich_text_field > ul > li')
      .forEach((element) => {
        element.className = '';
        element.classList.add('txt-body-m-regular');
        element.style.margin = '4px 0px 4px 40px';
      });
  }

  function applyTabletTypography() {
    const pdpModulesContentHeadline = document.querySelector('.Pdp-Modules-Content h2');
    if (pdpModulesContentHeadline) {
      pdpModulesContentHeadline.classList.remove('txt-headline-2xl-bold');
      pdpModulesContentHeadline.classList.add('txt-headline-2xl-bold');
    }

    document.querySelectorAll('.Pdp-Modules-Card-Title-Wrapper p').forEach((label) => {
      label.classList.remove('txt-label-m-regular');
      label.classList.add('txt-body-s-regular');
    });

    document.querySelectorAll('.Pdp-Modules-Card-Title-Wrapper h3').forEach((title) => {
      title.classList.remove('txt-body-s-bold');
      title.classList.add('txt-headline-m-bold');
    });

    document
      .querySelectorAll('.Pdp-Modules-Card-Date-Wrapper p, .Pdp-Modules-Card-Time-Wrapper p')
      .forEach((dateTime) => {
        dateTime.classList.remove('txt-label-m-regular');
        dateTime.classList.add('txt-body-m-regular');
      });

    document.querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper h4').forEach((hiddenHeadline) => {
      hiddenHeadline.classList.remove('txt-body-s-bold');
      hiddenHeadline.classList.add('txt-body-m-bold');
    });

    document.querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper p').forEach((hiddenSubtext) => {
      hiddenSubtext.classList.remove('txt-body-s-regular');
      hiddenSubtext.classList.add('txt-body-m-regular');
    });

    document.querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper h4').forEach((expertsHeadline) => {
      expertsHeadline.classList.remove('txt-body-s-bold');
      expertsHeadline.classList.add('txt-body-m-bold');
    });

    document
      .querySelectorAll('.Pdp-Modules-Card-Hidden-Speaker-Titel-Wrapper > p:first-child')
      .forEach((expertName) => {
        expertName.classList.remove('txt-body-s-regular');
        expertName.classList.add('txt-body-m-regular');
      });

    document
      .querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper > .metafield-rich_text_field > strong')
      .forEach((element) => {
        element.className = '';
        element.classList.add('txt-body-m-bold');
        element.style.marginBottom = '8px';
      });

    document
      .querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper > .metafield-rich_text_field > p')
      .forEach((element) => {
        element.className = '';
        element.classList.add('txt-body-m-regular');
      });

    document
      .querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper > .metafield-rich_text_field > ul')
      .forEach((element) => {
        element.style.listStylePosition = 'outside';
      });

    document
      .querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper > .metafield-rich_text_field > ul > li')
      .forEach((element) => {
        element.className = '';
        element.classList.add('txt-body-m-regular');
        element.style.margin = '4px 0px 4px 40px';
      });
  }

  function applyDesktopTypography() {
    const pdpModulesContentHeadline = document.querySelector('.Pdp-Modules-Content h2');
    if (pdpModulesContentHeadline) {
      pdpModulesContentHeadline.classList.remove('txt-headline-2xl-bold');
      pdpModulesContentHeadline.classList.add('txt-headline-2xl-bold');
    }

    document.querySelectorAll('.Pdp-Modules-Card-Title-Wrapper p').forEach((label) => {
      label.classList.remove('txt-label-m-regular');
      label.classList.add('txt-body-s-regular');
    });

    document.querySelectorAll('.Pdp-Modules-Card-Title-Wrapper h3').forEach((title) => {
      title.classList.remove('txt-body-s-bold');
      title.classList.add('txt-headline-m-bold');
    });

    document
      .querySelectorAll('.Pdp-Modules-Card-Date-Wrapper p, .Pdp-Modules-Card-Time-Wrapper p')
      .forEach((dateTime) => {
        dateTime.classList.remove('txt-label-m-regular');
        dateTime.classList.add('txt-body-m-regular');
      });

    document.querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper h4').forEach((hiddenHeadline) => {
      hiddenHeadline.classList.remove('txt-body-s-bold');
      hiddenHeadline.classList.add('txt-body-m-bold');
    });

    document.querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper p').forEach((hiddenSubtext) => {
      hiddenSubtext.classList.remove('txt-body-s-regular');
      hiddenSubtext.classList.add('txt-body-m-regular');
    });

    document.querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper h4').forEach((expertsHeadline) => {
      expertsHeadline.classList.remove('txt-body-s-bold');
      expertsHeadline.classList.add('txt-body-m-bold');
    });

    document
      .querySelectorAll('.Pdp-Modules-Card-Hidden-Speaker-Titel-Wrapper > p:first-child')
      .forEach((expertName) => {
        expertName.classList.remove('txt-body-s-regular');
        expertName.classList.add('txt-body-m-regular');
      });

    document
      .querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper > .metafield-rich_text_field > strong')
      .forEach((element) => {
        element.className = '';
        element.classList.add('txt-body-m-bold');
        element.style.marginBottom = '8px';
      });

    document
      .querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper > .metafield-rich_text_field > p')
      .forEach((element) => {
        element.className = '';
        element.classList.add('txt-body-m-regular');
      });

    document
      .querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper > .metafield-rich_text_field > ul')
      .forEach((element) => {
        element.style.listStylePosition = 'outside';
      });

    document
      .querySelectorAll('.Pdp-Modules-Card-Hidden-Text-Wrapper > .metafield-rich_text_field > ul > li')
      .forEach((element) => {
        element.className = '';
        element.classList.add('txt-body-m-regular');
        element.style.margin = '4px 0px 4px 40px';
      });
  }

  function updateResponsiveModules() {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 320 && screenWidth <= 767) {
      applyMobileTypography();
    } else if (screenWidth >= 768 && screenWidth <= 1023) {
      applyTabletTypography();
    } else if (screenWidth >= 1024 && screenWidth <= 1439) {
      applyDesktopTypography();
    } else if (screenWidth >= 1439) {
      applyDesktopTypography();
    }
  }

  function openModuleCard(card) {
    if (!card) return;
    const moduleCardHiddenContent = card.querySelector('.Pdp-Modules-Card-Hidden');
    const moduleCardContent = card.querySelector('.Pdp-Modules-Card-Content');
    const chevron = card.querySelector('.Pdp-Modules-Card-Button-Chevron');
    if (!moduleCardHiddenContent || !moduleCardContent || !chevron) return;

    // Set initial height to auto to get proper scrollHeight
    moduleCardHiddenContent.style.maxHeight = 'none';
    const scrollHeight = moduleCardHiddenContent.scrollHeight;

    // Now set the proper maxHeight
    moduleCardHiddenContent.style.maxHeight = scrollHeight + 'px';
    moduleCardHiddenContent.classList.add('open');

    if (window.innerWidth >= 320 && window.innerWidth <= 767) {
      moduleCardContent.style.paddingBottom = '16px';
      moduleCardContent.style.borderBottom = '#585A62 solid 1px';
      card.style.gap = '16px';
    } else {
      moduleCardContent.style.paddingBottom = '24px';
      moduleCardContent.style.borderBottom = '#585A62 solid 1px';
      card.style.gap = '24px';
    }
    chevron.style.transform = 'rotate(180deg)';
  }

  function closeModuleCard(card) {
    if (!card) return;
    const moduleCardHiddenContent = card.querySelector('.Pdp-Modules-Card-Hidden');
    const moduleCardContent = card.querySelector('.Pdp-Modules-Card-Content');
    const chevron = card.querySelector('.Pdp-Modules-Card-Button-Chevron');
    if (!moduleCardHiddenContent || !moduleCardContent || !chevron) return;

    moduleCardHiddenContent.style.maxHeight = null;
    moduleCardHiddenContent.classList.remove('open');
    moduleCardContent.style.paddingBottom = '0px';
    moduleCardContent.style.borderBottom = 'unset';
    card.style.gap = '0px';
    chevron.style.transform = 'rotate(0deg)';
  }

  function waitForImages(card) {
    return new Promise((resolve) => {
      if (!card) {
        resolve();
        return;
      }
      const images = card.querySelectorAll('img');
      let loadedImages = 0;

      if (images.length === 0) {
        resolve();
        return;
      }

      images.forEach((img) => {
        if (img.complete) {
          loadedImages++;
          if (loadedImages === images.length) {
            resolve();
          }
        } else {
          img.addEventListener('load', () => {
            loadedImages++;
            if (loadedImages === images.length) {
              resolve();
            }
          });
        }
      });
    });
  }

  function initAccordion() {
    const moduleCardTriggers = document.querySelectorAll('.Pdp-Modules-Card');
    if (!moduleCardTriggers.length) return;

    moduleCardTriggers.forEach((card) => {
      card.addEventListener('click', async () => {
        const moduleCardHiddenContent = card.querySelector('.Pdp-Modules-Card-Hidden');
        if (!moduleCardHiddenContent) return;
        const isModuleCardOpen = moduleCardHiddenContent.classList.contains('open');

        // Close all open module cards
        const openModuleCards = document.querySelectorAll('.Pdp-Modules-Card-Hidden.open');
        openModuleCards.forEach((openCard) => {
          closeModuleCard(openCard.parentElement);
        });

        // Toggle the current module card
        if (!isModuleCardOpen) {
          await waitForImages(card);
          openModuleCard(card);
        }
      });
    });

    // Auto-open first card for Deep-Dive-Einzelsession / Digital Marketing School
    const section = document.getElementById('Pdp-Modules-Section');
    if (section) {
      const productType = section.getAttribute('type');
      if (
        productType === 'OMR Deep Dive Einzelsession' ||
        productType === 'OMR Digital Marketing School'
      ) {
        setTimeout(async () => {
          const firstCard = document.querySelector('.Pdp-Modules-Card');
          if (firstCard) {
            await waitForImages(firstCard);
            openModuleCard(firstCard);
          }
        }, 100);
      }
    }
  }

  // Init
  initAccordion();
  updateResponsiveModules();
  window.addEventListener('resize', updateResponsiveModules);
})();
